document.addEventListener("DOMContentLoaded", () => {
	// --- Utilitaire : hex -> rgba ---
	const hexToRgba = (hex, alpha = 1) => {
		if (!hex) return `rgba(0,0,0,${alpha})`;

		// 🆕 Si c’est une variable CSS, on garde la variable et on applique l’opacité en CSS pur
		if (hex.startsWith("var(")) {
			return `color-mix(in srgb, ${hex} ${alpha * 100}%, transparent)`;
		}

		const h = hex.replace("#", "");
		let r, g, b;
		if (h.length === 6) {
			r = parseInt(h.slice(0, 2), 16);
			g = parseInt(h.slice(2, 4), 16);
			b = parseInt(h.slice(4, 6), 16);
		} else if (h.length === 3) {
			r = parseInt(h[0] + h[0], 16);
			g = parseInt(h[1] + h[1], 16);
			b = parseInt(h[2] + h[2], 16);
		} else {
			return `rgba(0,0,0,${alpha})`;
		}
		return `rgba(${r}, ${g}, ${b}, ${alpha})`;
	};


	const carousels = document.querySelectorAll(".eboutique-carousel");

	carousels.forEach((carousel) => {
		const track = carousel.querySelector(".eboutique-carousel__track");
		if (!track) return;

		const transitionType = carousel.dataset.transition || "slide";

		// --- Préparer les slides (et clones si slide) ---
		let slides = Array.from(track.children);
		if (transitionType === "slide") {
			// clones pour infinite loop
			const firstClone = slides[0].cloneNode(true);
			const lastClone = slides[slides.length - 1].cloneNode(true);
			firstClone.classList.add("clone");
			lastClone.classList.add("clone");
			track.appendChild(firstClone);
			track.insertBefore(lastClone, slides[0]);
			slides = Array.from(track.children);
		}

		const prevBtn = carousel.querySelector(".eboutique-carousel__prev");
		const nextBtn = carousel.querySelector(".eboutique-carousel__next");
		const dotsWrapper = carousel.querySelector(".eboutique-carousel__dots");
		const dotBorderRadius = parseFloat(dotsWrapper?.dataset.dotBorderRadius || "50");
		const timerWrapper = carousel.querySelector(".eboutique-carousel__autoplay-timer");
		const timerCircle = timerWrapper?.querySelector("circle");

		let index = 0;
		let dots = [];
		let startTime = null;
		let animationFrameId = null;
		let autoplayInterval = null;

		const autoplay = carousel.dataset.autoplay === "true";
		const autoplayDelay = parseInt(carousel.dataset.autoplayDelay, 10) || 5000;

		let radius = 0;
		let circumference = 0;
		if (timerCircle) {
			radius = timerCircle.r.baseVal.value;
			circumference = 2 * Math.PI * radius;
			timerCircle.style.strokeDasharray = circumference;
			timerCircle.style.strokeDashoffset = circumference;
		}

		const resetTimer = () => {
			startTime = null;
			if (timerCircle) timerCircle.style.strokeDashoffset = circumference;
			animationFrameId = requestAnimationFrame(animateTimer);
		};

		const animateTimer = (timestamp) => {
			if (!startTime) startTime = timestamp;
			const elapsed = timestamp - startTime;
			const progress = Math.min(elapsed / autoplayDelay, 1);
			if (timerCircle) timerCircle.style.strokeDashoffset = circumference * (1 - progress);
			if (progress < 1) animationFrameId = requestAnimationFrame(animateTimer);
		};

		// --- Initialisation ---
		if (transitionType === "slide") {
			track.style.transition = "none";
			track.style.transform = "translateX(-100%)";
		} else {
			slides.forEach((slide) => slide.classList.remove("is-active"));
			slides[0].classList.add("is-active");
			track.style.transition = "none";
			track.style.transform = "none";
		}

		// --- Dots ---
		if (dotsWrapper) {
			const dotBgHex = dotsWrapper.dataset.dotBgHex || "";
			const dotActiveBgHex = dotsWrapper.dataset.dotActiveBgHex || "";
			const dotOpacity = parseFloat(dotsWrapper.dataset.dotOpacity || "1");
			const dotBorderColorHex = dotsWrapper.dataset.dotBorderColorHex || "";
			const dotBorderWidth = parseInt(dotsWrapper.dataset.dotBorderWidth || "0");

			const realSlides = transitionType === "slide" ? slides.slice(1, -1) : slides;

			realSlides.forEach((_, i) => {
				const dot = document.createElement("button");
				dot.className = "eboutique-carousel__dot";
				dot.style.backgroundColor = hexToRgba(dotBgHex, dotOpacity);
				const borderWidthEm = dotBorderWidth / 16;
				dot.style.border = dotBorderWidth
					? `${dotBorderWidth}px solid ${dotBorderColorHex || "#000"}`
					: "none";
				dot.style.borderRadius = `${dotBorderRadius}%`;
				dot.addEventListener("click", () => {
					index = i;
					moveToSlide(i);
					resetTimer();
				});

				dotsWrapper.appendChild(dot);
				dots.push(dot);
			});
		}

		// --- Transition logic ---
		const moveToSlide = (i) => {
			if (transitionType === "slide") {
				track.style.transition = "transform 0.5s ease";
				track.style.transform = `translateX(-${(i + 1) * 100}%)`;
			} else if (transitionType === "fade") {
				slides.forEach((slide, idx) => {
					slide.classList.toggle("is-active", idx === i);
				});
			}
			updateDots();
		};

		const updateDots = () => {
			if (!dotsWrapper || dots.length === 0) return;

			let realIndex = index;
			const slideCount = transitionType === "slide" ? slides.length - 2 : slides.length;

			if (realIndex < 0) realIndex = slideCount - 1;
			if (realIndex >= slideCount) realIndex = 0;

			dots.forEach((dot, i) => {
				const isActive = i === realIndex;
				dot.classList.toggle("is-active", isActive);
				dot.style.backgroundColor = isActive
					? hexToRgba(
						dotsWrapper.dataset.dotActiveBgHex || dotsWrapper.dataset.dotBgHex,
						parseFloat(dotsWrapper.dataset.dotOpacity || 1)
					)
					: hexToRgba(dotsWrapper.dataset.dotBgHex, parseFloat(dotsWrapper.dataset.dotOpacity || 1));
			});
		};

		const handleInfiniteLoop = () => {
			if (transitionType !== "slide") return;
			if (index >= slides.length - 2) {
				setTimeout(() => {
					track.style.transition = "none";
					index = 0;
					track.style.transform = "translateX(-100%)";
				}, 500);
			}
			if (index < 0) {
				setTimeout(() => {
					track.style.transition = "none";
					index = slides.length - 3;
					track.style.transform = `translateX(-${(index + 1) * 100}%)`;
				}, 500);
			}
		};

		// --- Application des styles flèches ---
		const applyArrowStyles = (btn, isPrev = false) => {
			if (!btn) return;
			const bgHex = btn.dataset.arrowBgHex || "";
			const opacity = parseFloat(btn.dataset.arrowOpacity || "1");
			const borderHex = btn.dataset.arrowBorderHex || "";
			const borderWidth = parseInt(btn.dataset.arrowBorderWidth || "0");
			const size = parseInt(btn.dataset.arrowSize || "40");
			const offsetX = parseInt(btn.dataset.arrowOffsetX || "10");
			const borderRadius = parseFloat(btn.dataset.arrowBorderRadius || "50");

			btn.style.backgroundColor = hexToRgba(bgHex, opacity);
			btn.style.border = borderWidth ? `${borderWidth}px solid ${borderHex || "#000"}` : "none";
			btn.style.width = `${size}px`;
			btn.style.height = `${size}px`;
			btn.style[isPrev ? "left" : "right"] = `${offsetX}px`;
			btn.style.borderRadius = `${borderRadius}%`;
		};

		applyArrowStyles(prevBtn, true);
		applyArrowStyles(nextBtn, false);

		// --- Navigation flèches ---
		if (prevBtn) {
			prevBtn.addEventListener("click", () => {
				if (transitionType === "fade") {
					index = (index - 1 + slides.length) % slides.length;
					moveToSlide(index);
				} else {
					index--;
					track.style.transition = "transform 0.5s ease";
					track.style.transform = `translateX(-${(index + 1) * 100}%)`;
				}
				handleInfiniteLoop();
				updateDots();
				resetTimer();
			});
		}

		if (nextBtn) {
			nextBtn.addEventListener("click", () => {
				if (transitionType === "fade") {
					index = (index + 1) % slides.length;
					moveToSlide(index);
				} else {
					index++;
					track.style.transition = "transform 0.5s ease";
					track.style.transform = `translateX(-${(index + 1) * 100}%)`;
				}
				handleInfiniteLoop();
				updateDots();
				resetTimer();
			});
		}

		// --- Autoplay ---
		if (autoplay && slides.length > 1) {
			resetTimer();
			const startAutoplay = () => {
				autoplayInterval = setInterval(() => {
					index = (index + 1) % (transitionType === "slide" ? slides.length - 2 : slides.length);
					if (transitionType === "fade") {
						moveToSlide(index);
					} else {
						track.style.transition = "transform 0.5s ease";
						track.style.transform = `translateX(-${(index + 1) * 100}%)`;
						handleInfiniteLoop();
					}
					updateDots();
					resetTimer();
				}, autoplayDelay);
			};
			startAutoplay();

			carousel.addEventListener("mouseenter", () => {
				clearInterval(autoplayInterval);
				cancelAnimationFrame(animationFrameId);
			});
			carousel.addEventListener("mouseleave", () => {
				startAutoplay();
				resetTimer();
			});
		}

		updateDots();
	});
});
